export default __webpack_public_path__ + "static/media/img-box-3.c6d8a407.jpg";